<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- Header -->
    <header-component :headerTitle="headerText" />
     <v-snackbar
      v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :location="snackbar.position === 'top' ? 'top' : 'bottom'">
      <v-layout align-center pr-4>
        <v-icon class="ml-2 pr-3" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog content-class="filter-dispatch" v-model="filteWithSubPopup" persistent max-width="350px">
        <v-card  class="filter_ui">
          <v-card-actions>
            <v-combobox v-model="vendor_type" :items="vendor_type_items" class="ma-2" item-title="name" item-value="id"
              label="Vendor Type" variant="outlined"> </v-combobox>
            <!-- <v-combobox v-model="mapping_to" :items="mapping_to_items" class="ma-2" item-title="name" item-value="id"
              label="Mapping To" variant="outlined"> </v-combobox>
            <v-combobox v-model="status" :items="status_items" class="ma-2" item-title="name" item-value="id"
              label="Status" variant="outlined"> </v-combobox> -->
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn variant="outlined" size="small" class="text-none" text color="normal" @click="filteWithSubPopup = false">Cancel</v-btn>
            <v-btn variant="flat" size="small" color="primary" class="text-none" @click="applyFilter('filter')">Apply Filter(s)</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Download popup -->
    <v-row justify="center">
      <v-dialog v-model="downloadDialog" persistent max-width="364px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex">
            <span>Download</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="downloadDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-50 m-0"/>
          <v-card-text class="download-email">
            <v-row>
              <v-col cols="12" sm="4" md="12">
                <v-text-field label="Email Id" variant="outlined" v-model="email_id" type="text" :rules="emailRules" @input="validateEmail"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn size="large" class="text-none" variant="outlined" color="primary" large @click="downloadDialog = false">Cancel</v-btn>
            <v-btn size="large" class="text-none" variant="flat" color="primary" large @click="downloadFile('submit')" :disabled="!isEmailValid || number > 0">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-card class="v-card-100 mt-6">
      <v-tabs v-model='tab_index'>
        <v-tab class="component-tab-heading"ripple :href="'#'" style="text-transform:none!important;" @click="loadData(tab, 'tab_clicked')"
          v-for="(tab, index) in tabs" :key="index">{{
            tab }}</v-tab>
      </v-tabs>
    </v-card>

    <!-- seacrh, action button and filter -->
    <v-card class="v-card-100 mt-0">
      <v-card-title style="padding:28px" class="action-style pb-0">
        <!-- Search fields -->
        <v-row class="ma-1">
          <v-autocomplete v-model="search_field1" :items="search_field_master_data" label="Select Field" variant="outlined" style="max-width: 158px;padding-right: 10px;" class="mr-4">
            <template #item="{ props }">
            <v-list-item v-bind="props" class="multiline-list-item">
              <v-list-item-content>
                <v-list-item-title class="custom-title" v-html="name"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          </v-autocomplete>
          <v-text-field prepend-inner-icon="mdi-magnify" v-model="search_tag" v-no-edge-space label="Search" style="max-width: 270px;" :disabled="!search_field1" variant="outlined" v-on:keyup.enter="applyFilter('search')"></v-text-field>
          <v-spacer></v-spacer>
          <v-actions>
            <v-btn class="mr-2 custum-button text-none" v-if="selected.length > 0" @click="downloadFile('selected')" color="primary" large style="min-height:55px; min-width:130px; font-weight:600;">Download</v-btn>
            <v-btn class="mr-2 custum-button text-none" v-if="selected.length === 0" @click="openPopup" color="primary" large style="min-height:55px; min-width:130px; font-weight:600;">Download</v-btn>
            <v-btn class="mr-2 custum-button text-none" @click="navigateToFileUpload" color="primary" large style="min-height:55px; min-width:100px; font-weight:600;">Upload</v-btn>
            <!-- <v-btn @click="navigateToAddBuyers('add')" class="mr-2 pa-2"  color="primary">Add Buyer</v-btn> -->
            <!-- <v-btn class="mr-2 pa-2" :disabled="selected.length == 0" @click="deletRequest('delete')" color="primary">Delete</v-btn> -->
            <!-- <v-btn class="mr-2 pa-2" :disabled="(selected.length !== 1)" @click="navigateToAddBuyers('edit')" color="primary">Edit</v-btn> -->
            <!-- <v-btn class="mr-2 pa-2" :disabled="selected.length == 0" @click="deletRequest('block')" color="primary">Block</v-btn> -->
            <!-- <v-btn class="mr-2 pa-2" :disabled="selected.length == 0" @click="deletRequest('unblock')" color="primary">Unblock</v-btn> -->
          </v-actions>
          <!-- Filter -->
          <v-expansion-panels class="custom-control_outlined" ref="filterPopupRef" readonly
            style="max-width: 110px; margin-bottom: 28px; min-height: 56px;" v-if="this.active_tab == 'Vendor Master'">
            <v-expansion-panel variant="outlined" @click="filterListOfButtons">
              <v-expansion-panel-title>Filter
                <template v-slot:actions>
                  <v-icon color="primary">
                    mdi-menu-down
                  </v-icon>
                </template>
              </v-expansion-panel-title>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </v-card-title></v-card>
    <v-layout column>
      <!-- <v-flex md6 style="overflow: auto">? -->
        <v-data-table 
           density="compact" 
           :items-per-page="pageSize"
           v-model="selected" 
           show-select 
           disable-pagination 
           :hide-default-footer="true"
          :headers="headers" 
          :items="table_data"
          return-object 
          fixed-header
          height="100%"
          :loading="loading"
          loading-text="Loading Data... Please wait" class="elevation-1">
          <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers">
              <span v-if="header.key == 'buyer_code'">
                <a href="#" @click.prevent="navigateToBuyerDetails(item)" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">
                  {{ item.buyer_code }}
                </a>
              </span> 
              <span v-else-if="header.key !== 'images' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else-if="header.key == 'vendor_name'">
                <span v-if="item.vendor_name !== null && item.vendor_name.length <= 10">
                {{ item.vendor_name }}
              </span>
              <span v-else>
                <v-tooltip top>
                  <template v-slot:activator="{ props }">
                    <a v-bind="props">
                      {{ item.vendor_name.substring(0, 10) }}...
                    </a>
                  </template>
                  <div style="max-width: 400px; word-wrap: break-word;">
                  <span>{{ item.vendor_name }}</span>
                </div>
                </v-tooltip>
              </span>
              </span> 
              <span v-else-if="header.key == 'vendor_code'">
                <span v-if="item.vendor_code !== null && item.vendor_code.length <= 10">
                {{ item.vendor_code }}
              </span>
              <span v-else>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <a v-bind="attrs" v-on="on">
                      {{ item.vendor_code.substring(0, 10) }}...
                    </a>
                  </template>
                  <div style="max-width: 400px; word-wrap: break-word;">
                  <span>{{ item.vendor_code }}</span>
                </div>
                </v-tooltip>
              </span>
              </span>
              <span v-else>-</span>
            </template>

          <!-- <template v-for="(header, index) in headers" v-slot:[`item.${header.value}`]="{ item }">
            <span v-if="item[header.value] !== null && item[header.value] !== ''">
              {{ item[header.value] }}
            </span>
            <span v-else>
              <span>-</span>
            </span>
          </template>
          <template #[`item.buyer_code`]="{ item }">
            <a @click="navigateToBuyerDetails(item)" style="color: #1976d2; cursor: pointer;">
              <u>{{ item.buyer_code }}</u>
            </a>
          </template> -->
          <!-- <template v-slot:item.vendor_name="{ item }">
            <span v-if="item.vendor_name !== null && item.vendor_name.length <= 10">
                {{ item.vendor_name }}
              </span>
              <span v-else-if="item.vendor_name === null">
                -
              </span>
              <span v-else>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <a v-bind="attrs" v-on="on">
                      {{ item.vendor_name.substring(0, 10) }}...
                    </a>
                  </template>
                  <div style="max-width: 400px; word-wrap: break-word;">
                  <span>{{ item.vendor_name }}</span>
                </div>
                </v-tooltip>
              </span>
          </template> -->
          <!-- <template v-slot:item.vendor_code="{ item }">
            <span v-if="item.vendor_code !== null && item.vendor_code.length <= 10">
                {{ item.vendor_code }}
              </span>
              <span v-else-if="item.vendor_code === null">
                -
              </span>
              <span v-else>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <a v-bind="attrs" v-on="on">
                      {{ item.vendor_code.substring(0, 10) }}...
                    </a>
                  </template>
                  <div style="max-width: 400px; word-wrap: break-word;">
                  <span>{{ item.vendor_code }}</span>
                </div>
                </v-tooltip>
              </span>
          </template> -->
          <template #bottom></template>
        </v-data-table>
      <!-- </v-flex> -->
    </v-layout>

    <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
  </v-card>
</template>
<script>
import HeaderComponent from '../../../../commoncomponents/HeaderComponent.vue';
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
export default {
  data() {
    return {
      headerText: "Vendor Master",
      alert: false,
      alert_type: 'info',
      alert_message: '',
      search_tag: '',
      selected: [],
      active_tab: 'Vendor Master',
      tabs: [
        'Vendor Master',
        'Vendor Mapping'
      ],
      snackbar: false,
      snackbarColor: '',
      table_data: [],
      search_field1: null,
      search_field_master_data: [],
      headers: [],
      page: 1,
      totalPages: 1,
      totalCount: '',
      pageSize: defaultPageSize,
      pageSizes: defaultPageSizes,
      filteWithSubPopup: false,
      isFiltering: false,
      vendor_type: null,
      mapping_to: '',
      status: '',
      download_message: '',
      vendor_type_items: [],
      mapping_to_items: [],
      status_items: [],
      tab_index: 0,
      organization_name:'',
      downloadDialog:false,
        email_id:'',
        email_format_rule: [
          v => (/^[\w,.]+([\.-]?[\w,.]+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email_id)) || "Please enter valid Email"
        ],
      snackbar: {
          color: null,
          icon: null,
          mode: null,
          position: "top",
          text: null,
          timeout: 3000,
          title: null,
          visible: false,
          isEmailValid:true,
          emailError:'',
        },
    }
  },
  components: {
    HeaderComponent
  },
  created() {
    this.active_tab_condi = this.$store.state.active_tab;
    this.organization_name = this.$store.state.organization_name;
    this.filterOptions()
      if(this.active_tab_condi === 'first_tab'){
        this.tab_index = 0;
        this.loadData('Vendor Master');
      }else if(this.active_tab_condi === 'second_tab'){
        this.tab_index = 1;
        this.loadData('Vendor Mapping');
      }else{
        this.loadData('Vendor Master');
        this.filterOptions();
      }
  },
  computed: {
    emailRules() {
      return [
        v => this.emailError || true
      ];
    }
  },
  methods: {
    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.scrollToTop();
      this.alertTimeOut();
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1
      if(this.isFiltering == true){
        this.applyFilter()
        return
      }
      this.fetchIndexData();

    },
    handlePageChange(value) {
      this.page = value;
      if(this.isFiltering == true){
        this.filterPage = value;
        this.applyFilter()
        return
      }
      this.fetchIndexData();
    },
    loadData(tab, tab_action) {
      if (tab_action) {
        this.search_tag = '';
        this.search_field1=null;
      }
      this.loading = false;
      this.isFiltering = false;
      this.active_tab = tab
      this.selected = []
      this.table_data = []
      this.page = 1
      this.totalPages = 1
      if(tab == 'Vendor Master'){
        this.$store.commit("setActiveTab", {
          active_tab:'first_tab'
        });
        this.headers = [
          { title: "Organization", key : "org_name" },
          { title: "Vendor Code", key : "vendor_code" },
          { title: "Vendor Name", key : "vendor_name" },
          { title: "Vendor Type", key : "vendor_type" },
          { title: "Dealer Type", key: "dealer_type" },
          { title: "Primary Mobile Number", key : "vendor_phone"},
          { title: "Alternate Mobile Number", key : "alternate_contact_no" },
          { title: "Email ID", key : "vendor_email" },
          { title: "GST Number", key : "gst_number" },
          { title: "PAN Number", key : "pan_number" },
          { title: "Branch", key : "branch" },
          // { text: "Generic Field 2", value: "" },
          // { text: "Generic Field 1", value: "" },
          // { text: "Currency", value: "currency" },
          // { text: "Payment Terms", value: "payment_terms" },
          // { text: "Credit Days", value: "credit_days" },
          // { text: "Bank Account Name", value: "account_name" },
          // { text: "Bank Account Number", value: "account_number" },
          // { text: "Bank Name", value: "bank_name" },
          // { text: "IFSC Code", value: "ifsc_code" },
          // { text: "Bank Branch", value: "bank_branch" },
          // { text: "UPI ID", value: "upi_id" },
        ];
        this.search_field_master_data = [
          'Organization',
          'Vendor Code',
          'Vendor Name',
          'Primary Mobile Number',
          'Email ID',
          'PAN Number',
          'Branch'
        ]
        if (this.$isWhirlpoolClient()) {
              this.headers = [
              { title: "Organization", key: "org_name" },
              { title: "Vendor Code", key: "vendor_code" },
              { title: "Vendor Name", key: "vendor_name" },
              { title: "Vendor Type", key: "vendor_type" },
              { title: "Primary Mobile Number", key: "vendor_phone" },
              { title: "Alternate Mobile Number", key: "alternate_contact_no" },
              { title: "Email ID", key: "vendor_email" },
              { title: "GST Number", key: "gst_number" },
              { title: "PAN Number", key: "pan_number" },
            ];
            this.search_field_master_data = [
              'Organization',
              'Vendor Code',
              'Vendor Name',
              'Primary Mobile Number',
              'Email ID',
              'PAN Number'
              ];
            }else if (this.$isRelianceClient()) {
              const fieldsToRemove = ["branch", "dealer_type"];
              this.headers = this.headers.filter(header => !fieldsToRemove.includes(header.key));
              this.search_field_master_data = [
                        'Organization',
                        'Vendor Code',
                        'Vendor Name',
                        'Primary Mobile Number',
                        'Email ID',
                        'PAN Number'
                      ]
            }
      }else if(tab == 'Vendor Mapping'){
        this.$store.commit("setActiveTab", {
          active_tab:'second_tab'
        });
        this.headers = [
          { title : "Vendor ID", key : "vendor_code" },
          { title : "Vendor Email", key : "vendor_email" },
          { title : "Mapped User ID", key : "mapped_users" },
          { title : "Mapped Vendor ID", key : "mapped_vendor" },
          { title : "Mapped PIN Codes", key : "mapped_pin_codes" },
          { title : "Mapped Reverse Dispatch(Processing) Locations", key : "mapped_reverse_location" },
          { title : "Mapped Forward Dispatch Locations", key : "mapped_forward_locations" },
        ];
        this.search_field_master_data = [
          'Vendor ID',
          'Email ID',
          'Mapped User ID',
          'Mapped Vendor ID',
          'Mapped PIN Codes',
          'Mapped Reverse Dispatch (Processing) Locations',
          'Mapped Forward Dispatch Locations'
        ]
      }
      this.fetchIndexData();
    },
    fetchIndexData() {  
      this.loading = true;      
      const params = {
        page: this.page,
        per_page: this.pageSize,
        tab: this.active_tab,
      };     

      this.$httpSecured
        .get('/api/v2/vendor_masters', { params })
        .then(response => {
          if (response.data) {
            this.table_data = response.data.vendor_masters
            // .map(user => {
            //   return {
            //     ...user,
            //     roles: user.roles.join(', ')
            //   };
            // });
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.loading = false;
            // this.$store.commit("setActiveTab", {});
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
        });
    },
    afterClickOK() {
      this.snackbar = false
      this.$store.commit("setLotIds", {});
      this.loadData();
      this.snackbarColor = '';
    },
    openPopup(){
        this.downloadDialog = true;
        this.email_id = this.$store.state.currentUser.email;
        this.validateEmail(this.email_id)
      },
    downloadFile(value) {
      this.number++;
       const formData = new FormData();
        if(value === 'submit'){
          formData.append('email_ids', this.email_id);
        }else{
          const ids = this.selected.map(item => item.id);
          ids.forEach(id => formData.append('vendor_ids[]', id));
        } 
      let end_point = '';
      if(this.active_tab === 'Vendor Master'){
        end_point = '/api/v2/vendor_masters/download_vendors';
      }else{
        end_point = '/api/v2/vendor_masters/download_vendors?file_type=Vendor Configuration';
      }
      this.$httpSecured
        .post(end_point, formData)
        .then(response => {
          if (response.data) {
            if(value === 'submit'){
              this.snackbar = true;
              this.downloadDialog = false;
              this.email_id='';
              this.snackbar = {
                color: "success",
                icon: "mdi-check-circle",
                mode: "multi-line",
                position: "top",
                timeout: 3000,
                title: 'Success',
                text: response.data.message,
                visible: true
              };
            }else{
              const url = response.data.url;
              const link = document.createElement('a');
              link.href = url;
              link.download = '';
              document.body.appendChild(link);
              link.click();
              this.snackbar = {
                color: "success",
                icon: "mdi-check-circle",
                mode: "multi-line",
                position: "top",
                timeout: 3000,
                title: "Success",
                text: "(CSV File) Downloaded Successfully",
                visible: true
              };
            }           
            this.selected = [];
            this.number = 0;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
            this.number = 0;
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
          this.number = 0;
        });
    },
    navigateToFileUpload() {
      this.$store.commit("setLotIds", {
        lotIds: this.headerText,
        inventoryId: this.active_tab,
        action: 'first_tab'
      });
      this.$router.push({ name: "LotFileuploadComm" });
    },
    filterListOfButtons() {
      this.filteWithSubPopup = true;
      this.vendor_type = null;
      this.search_field1 = null;
      this.search_tag = '';
      document.documentElement.style.setProperty('--dialog-ypos', (this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40).toString() + 'px');
      this.filterOptions()
    },
    filterOptions() {
      this.$httpSecured
        .get(`/api/v2/vendor_masters/filter_options`)
        .then(response => {
          if (response.data) {
            this.vendor_type_items = response.data.vendor_type;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    applyFilter(filter_condi) {
      this.loading = true;
      this.isFiltering = true;
      const payload = {
            page: this.page,
            per_page: this.pageSize,
            tab: this.active_tab,
            filter: {}
          };
        if(filter_condi === 'search'){
          if(this.active_tab == 'Vendor Master'){
            if(this.search_field1 == 'Organization'){
              payload.filter['organization'] = this.search_tag;
            }else if(this.search_field1 == 'Branch'){
              payload.filter['branch'] = this.search_tag;
            }else if(this.search_field1 == 'Vendor Code'){
              payload.filter['vendor_code'] = this.search_tag;
            }else if(this.search_field1 == 'Vendor Name'){
              payload.filter['vendor_name'] = this.search_tag;
            }else if(this.search_field1 == 'Primary Mobile Number'){
              payload.filter['mobile_number'] = this.search_tag;
            }else if(this.search_field1 == 'Email ID'){
              payload.filter['email'] = this.search_tag;
            }else if(this.search_field1 == 'PAN Number'){
              payload.filter['pan'] = this.search_tag;
            }
          }else if(this.active_tab == 'Vendor Mapping'){
            if(this.search_field1 == 'Vendor ID'){
              payload.filter['vendor_code'] = this.search_tag;
            }else if(this.search_field1 == 'Mapped User ID'){
              payload.filter['mapped_user'] = this.search_tag;
            }else if(this.search_field1 == 'Mapped Vendor ID'){
              payload.filter['mapped_vendor'] = this.search_tag;
            }else if(this.search_field1 == 'Mapped PIN Codes'){
              payload.filter['mapped_pincodes'] =  this.search_tag;
            }else if(this.search_field1 == 'Mapped Reverse Dispatch (Processing) Locations'){
              payload.filter['reverse_location'] =  this.search_tag;
            }else if(this.search_field1 == 'Mapped Forward Dispatch Locations'){
              payload.filter['forward_location'] = this.search_tag;
            }else if(this.search_field1 == 'Email ID'){
              payload.filter['email'] =  this.search_tag;
            }
          }
        }else if(filter_condi === 'filter'){
            payload.filter['assigned_vendor_type'] = this.vendor_type
          }
      this.$httpSecured
        .post(`/api/v2/vendor_masters/index_new`, payload)
        .then(response => {
          if (response.data) {
            this.table_data = response.data.vendor_masters;
            this.filteWithSubPopup = false;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    validateEmail() {
      const emails = this.email_id.split(',').map(email => email.trim());
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (emails.length === 1 && !emailPattern.test(emails[0])) {
        this.emailError = 'Please enter a valid email';
        this.isEmailValid = false
        return;
      }else{
        this.isEmailValid = true
      }

      for (const email of emails) {
        if (!emailPattern.test(email)) {
          this.emailError = 'Please enter valid email ids separated by commas';
          this.isEmailValid = false
          return;
        }else{
          this.isEmailValid = true
        }
      }     

      this.emailError = null;
    },
  }
}
</script>
<style scoped>
.custom-control_outlined .v-expansion-panel:before {
  box-shadow: none;
}

.custom-control_outlined button {
  min-height: 56px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, .42);
  border-style: solid;
}

.custom-control_outlined button:focus {
  outline: none;
}

.v-dialog:has(.filter-dispatch) {
  justify-content: right;
  align-items: baseline;
  top: var(--dialog-ypos);
}

.item-selected {
  margin-top: 23px;
  position: absolute;
  left: 41%;
}

@media (max-height: 1104px) {
  .PaddingItemPerPage {
    padding: 8px !important;
  }
}

@media (min-height: 1126px) {
  .PaddingItemPerPage {
    padding: 24px !important;
  }
}
:deep(.multiline-list-item .v-list-item-title) {
  white-space: pre-wrap; /* Allows wrapping of text within the list item */
  word-break: break-word; /* Ensures words break and wrap appropriately */
  line-height: 1.2; /* Adjusts the line height for better readability */
  max-width:200px;
}
.v-data-table {
  height: calc(var(--vh, 1vh) * 100 - 325px) !important;
}
.filter_ui{
  margin-right: 24px !important;
  margin-top: 12px !important;
}
</style>